var _path, _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavIconLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 47,
    viewBox: "0 0 140 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.808 33.84C12.024 33.84 12.216 33.792 12.36 33.648C13.104 32.76 13.272 31.632 13.272 30.504C13.272 30.12 13.248 29.736 13.224 29.352C12.984 25.248 12.384 21.048 12.384 16.728C12.384 13.92 12.552 12.624 13.128 9.84C13.32 9.072 13.392 9.12 13.44 8.304C13.44 8.184 13.392 8.064 13.32 7.992C15.096 7.824 16.872 7.752 18.624 7.752L20.4 7.776C20.832 7.8 21.288 7.8 21.72 7.848C21.912 7.848 22.128 7.704 22.128 7.512C22.056 7.128 21.744 7.008 21.36 7.008C20.52 6.984 19.704 6.96 18.864 6.96C16.08 6.96 13.272 7.152 10.488 7.536C6.624 8.088 0.768 9.048 0.72 12.384C0.72 13.728 2.088 14.496 3.216 15.144C3.816 15.48 4.368 15.888 4.896 16.32C8.088 18.936 9.72 22.224 9.72 26.544L9.696 28.536C9.696 30.288 9.888 31.8 10.704 33.24C10.968 33.696 11.256 33.792 11.808 33.84ZM11.472 30.504L11.4 30.072L11.256 28.92C11.04 27.408 11.016 25.872 10.728 24.36C9.84 20.016 7.08 16.392 3.504 14.496C2.568 14.04 1.584 13.464 1.584 12.504C1.584 10.992 3.408 9.864 5.016 9.336C6.552 8.856 8.184 8.64 9.768 8.4L11.904 8.112C10.752 10.8 10.584 13.896 10.584 16.464C10.656 20.928 11.04 23.448 11.376 28.128C11.424 28.8 11.472 29.496 11.472 30.168V30.504ZM24.3818 31.224C24.6458 31.224 24.7178 31.152 24.7898 30.912C24.7898 30.744 24.6218 30.6 24.5018 30.528L24.0938 30.264C24.0458 30.216 23.9978 30.168 23.9498 30.144C22.5578 28.944 22.6538 26.16 22.3658 24.432C22.2458 23.664 21.9578 22.68 21.2858 22.68C20.9018 22.68 20.5178 22.968 20.2058 23.184C18.9098 24.096 18.3578 25.704 17.7098 27.216C17.6858 27.048 17.6858 26.88 17.6858 26.712C17.6378 25.632 17.6138 24.576 17.6138 23.496C17.6138 20.28 17.7338 18.672 17.8778 15.12L17.8538 14.352C17.8538 14.016 17.7098 13.728 17.6618 13.392C17.6138 13.176 17.3498 13.008 17.1098 13.008C16.9658 13.008 16.8698 13.056 16.7978 13.176C16.7018 13.416 16.5098 13.632 16.4618 13.872C16.2218 14.976 16.1738 15.216 16.0778 16.344C15.8857 18.528 15.8138 21.12 15.8138 23.304C15.8618 26.232 15.8138 24.888 15.9338 27.816C15.9818 28.44 15.9578 29.112 16.1498 29.736C16.2458 30.096 16.7498 30.312 17.1098 30.312C17.3738 30.312 17.6618 30.24 17.7818 30C17.8778 29.76 18.0218 29.52 18.1418 29.28C18.9578 27.504 19.0298 25.632 20.3258 23.976C20.5418 23.688 20.8058 23.424 21.1178 23.232C21.2378 23.16 21.3098 23.184 21.3098 23.136C21.3098 23.328 21.3818 23.52 21.3818 23.736L21.4058 25.704C21.4058 26.688 21.4297 27.648 21.7418 28.56C22.1258 29.712 22.9178 30.816 24.0938 31.176C24.1898 31.2 24.2858 31.224 24.3818 31.224ZM30.036 31.968C31.332 31.968 32.844 31.44 34.044 30.792C34.548 30.552 35.1 30.264 35.508 29.856C35.556 29.808 35.556 29.784 35.556 29.736C35.556 29.496 35.268 29.352 35.052 29.352C34.452 29.472 34.14 29.736 33.564 30C32.388 30.528 31.068 31.032 29.844 31.032C29.58 31.032 29.628 31.032 29.244 30.96L28.956 30.816C28.956 30.792 28.932 30.768 28.908 30.768L28.524 30.24C28.524 30.24 28.452 30.144 28.452 30.12C28.14 29.568 27.996 28.968 27.996 28.344C28.068 27.312 28.092 26.856 28.476 25.776C29.964 25.632 31.428 24.624 32.292 23.448C32.58 23.064 32.868 22.632 32.892 22.152C32.892 21.744 32.604 21.36 32.292 21.12C31.908 20.808 31.524 20.64 31.02 20.64C30.252 20.64 29.628 21.072 29.028 21.528C27.276 22.92 26.22 25.656 26.22 27.984C26.22 28.56 26.292 29.136 26.508 29.688C27.084 31.2 28.548 31.968 30.036 31.968ZM28.668 25.248C29.196 23.784 30.204 22.464 31.524 21.864C31.74 21.744 31.62 21.792 31.884 21.72C32.004 21.72 32.052 21.936 32.052 22.032C32.052 22.32 31.836 22.656 31.716 22.848C31.02 24.096 29.892 24.768 28.668 25.248ZM48.3287 34.272C48.7847 34.272 49.2407 34.176 49.6487 33.984C51.3527 33.192 51.7127 31.2 52.0727 29.544C52.8167 26.112 52.9847 23.256 53.0087 20.04C53.0087 17.472 52.7927 14.352 51.9287 11.832C51.3767 10.128 50.0567 8.64 48.3287 8.64C46.6727 8.664 45.6647 10.2 44.9207 11.52C44.1527 12.912 43.5287 14.112 43.0247 15.504V15.528C43.0247 15.648 43.1687 15.72 43.2887 15.72C43.3607 15.72 43.4327 15.648 43.4327 15.648C44.3447 14.136 45.0647 12.528 46.0727 11.064C46.6007 10.296 47.5127 9.264 48.5207 9.264C48.7607 9.264 49.0247 9.336 49.2887 9.48C49.9367 9.84 50.2247 10.488 50.4167 11.16C50.6567 11.952 50.7047 12.792 50.8007 13.584C51.0887 16.296 51.1847 17.544 51.2327 20.16C51.2327 23.424 50.8247 26.712 50.0807 29.904C49.9367 30.624 49.6967 31.416 49.3367 31.992C48.8807 32.544 48.8807 32.592 48.4247 32.832C48.4007 32.856 48.3527 32.904 48.2807 32.904C48.1127 32.952 48.1847 32.976 47.9927 32.976L47.9447 33H47.7287C47.4887 32.952 47.5607 32.808 47.3927 32.808L47.2487 32.592C47.2487 32.592 47.1287 32.4 47.1047 32.304C46.7927 31.632 46.6727 30.864 46.5527 30.144C46.4567 29.472 46.4087 28.776 46.4087 28.104C46.4087 24.912 47.2007 22.848 48.8087 20.088C48.8567 20.04 48.8567 19.968 48.8567 19.92C48.8567 19.68 48.4967 19.464 48.2087 19.464C48.0887 19.464 47.9927 19.488 47.9207 19.584C46.0007 22.08 45.0167 25.248 45.0167 28.368L45.0407 29.208C45.1367 30.864 45.3767 32.952 46.8167 33.864C47.2727 34.152 47.8007 34.272 48.3287 34.272ZM57.2228 29.904C57.7988 29.904 58.1828 29.592 58.5188 29.16C59.6708 27.672 60.1748 26.04 60.1748 24.216C60.1748 22.752 59.9348 20.952 59.0228 19.8C58.3268 18.936 57.4628 18.6 56.4068 18.576C55.6148 18.576 54.8708 18.888 54.4628 19.608L54.4388 19.704C54.4388 19.896 54.7748 20.088 55.0148 20.088C55.1348 20.088 55.2308 20.04 55.2788 19.968C55.6148 19.464 56.1668 19.2 56.7188 19.2C58.2548 19.2 59.0468 20.928 59.0468 22.56C59.0468 24.576 58.0628 26.808 56.9828 28.2C56.9588 28.224 56.9348 28.248 56.9348 28.272C56.8867 28.152 56.8628 28.008 56.8388 27.84C56.6708 26.976 56.6228 26.448 56.6228 25.536C56.6228 24.264 56.7668 22.8 57.2948 21.624C57.3428 21.456 57.4148 21.264 57.5348 21.168C57.6308 21.072 57.6548 21.096 57.7268 21.024L57.8468 21.048C58.0388 21.048 58.1828 20.904 58.1828 20.76C58.1828 20.448 57.5108 20.184 57.0548 20.184C55.3508 20.184 54.8948 22.968 54.8228 25.224C54.8228 26.064 54.9188 26.904 55.0628 27.72C55.1828 28.224 55.3027 28.68 55.5908 29.088C55.9268 29.568 56.5508 29.904 57.1508 29.904H57.2228ZM68.2346 31.008C68.6186 31.008 68.7866 30.6 68.7866 30.24C68.7626 29.328 68.8106 29.28 68.6906 28.368C68.4026 25.104 68.4506 25.44 68.0426 22.44C67.9946 22.032 67.8506 21.624 67.8026 21.216C67.7306 20.856 67.4426 20.808 67.1066 20.76C66.9386 20.76 66.7706 20.808 66.7226 20.952C66.5786 21.456 66.3146 21.912 66.0746 22.368C65.1866 24.072 64.5866 25.104 63.4106 26.928C63.4106 23.808 63.4586 24.816 63.5786 21.552C63.5786 21.384 63.5306 21.192 63.4826 21.024C63.4106 20.688 63.1706 20.64 62.8346 20.568C62.6906 20.568 62.5706 20.616 62.5226 20.688C62.3306 20.952 62.1866 21.192 62.1146 21.504C61.6586 23.304 61.6106 24 61.6106 25.968C61.6106 26.664 61.6346 27.36 61.7066 28.056C61.7546 28.848 62.4026 29.4 63.1946 29.4L63.5306 29.352C64.1306 29.208 64.4186 28.632 64.7306 28.152C65.6186 26.712 66.0266 25.896 66.7226 24.24C66.8426 26.856 66.8666 27.48 67.1546 29.832C67.2026 30.408 67.5626 31.008 68.2346 31.008ZM71.3876 29.712C71.5316 29.712 71.6756 29.664 71.7716 29.592C72.9476 28.776 73.0196 27.312 73.5236 25.968C73.7876 25.248 74.0756 24.552 74.4116 23.88C74.7476 23.16 75.1796 22.104 75.6356 21.528C75.6836 21.504 75.7316 21.456 75.7556 21.408C75.8276 21.408 75.8276 21.456 75.8756 21.456C75.8756 21.48 75.9236 21.504 75.9476 21.528C75.9476 21.528 76.3556 21.816 76.6196 21.816C76.8836 21.816 77.0516 21.6 77.0516 21.36C77.0516 20.688 76.0676 20.352 75.4676 20.352C74.8196 20.4 74.5556 20.52 74.0756 20.928C73.7876 21.192 73.5956 21.552 73.4036 21.888C72.9476 22.632 72.5636 23.424 72.2276 24.216C72.2276 23.928 72.2276 23.64 72.2516 23.352C72.2516 22.488 72.2276 22.704 72.2276 21.912C72.2276 21.696 72.1556 21.528 72.1076 21.312C72.0596 20.904 71.6996 20.832 71.2676 20.76C70.9076 20.76 70.7396 21.144 70.6916 21.528C70.6196 22.176 70.5956 22.32 70.5476 22.944C70.4036 25.056 70.3076 27.12 70.2356 28.92C70.2356 29.424 70.9316 29.712 71.3876 29.712ZM79.9039 31.824C80.2159 31.824 80.4799 31.68 80.5039 31.32C80.6719 29.736 80.9359 28.2 81.3439 26.664C81.7519 25.128 82.3519 23.664 82.9759 22.2C83.2159 21.552 83.3359 21.312 83.6479 20.712C83.9119 22.632 83.8399 24.192 84.5359 25.848C85.1839 27.36 86.5279 28.848 88.3519 28.968C88.6639 28.968 89.0239 28.872 89.0239 28.512C89.0239 28.056 88.5199 27.816 88.1119 27.744L87.7759 27.624C87.6319 27.552 87.6559 27.624 87.4639 27.432C87.2959 27.36 87.2959 27.312 87.1279 27.168C87.1279 27.144 87.0559 27.096 87.0559 27.072C85.4959 25.248 85.8079 23.184 85.0879 20.616C84.9679 20.232 84.8479 19.8 84.6319 19.44C84.3679 19.08 83.9359 18.84 83.5039 18.84C82.8559 18.936 82.6639 19.176 82.3279 19.68C81.2959 21.072 80.5999 22.872 80.0719 24.432L80.1679 19.584C80.1679 19.344 80.1679 19.08 80.1439 18.84C80.1439 18.456 80.0959 17.784 79.6399 17.784C79.5679 17.784 79.4719 17.808 79.4479 17.904C79.2079 18.528 79.2319 18.504 79.0879 19.08C78.6799 21.576 78.3919 23.76 78.3919 26.28C78.3919 27.888 78.5119 29.52 78.7279 31.032C78.7999 31.464 79.4239 31.824 79.9039 31.824ZM94.2782 31.968C95.5742 31.968 97.0862 31.44 98.2862 30.792C98.7902 30.552 99.3422 30.264 99.7502 29.856C99.7982 29.808 99.7982 29.784 99.7982 29.736C99.7982 29.496 99.5102 29.352 99.2942 29.352C98.6942 29.472 98.3822 29.736 97.8062 30C96.6302 30.528 95.3102 31.032 94.0862 31.032C93.8222 31.032 93.8702 31.032 93.4862 30.96L93.1982 30.816C93.1982 30.792 93.1742 30.768 93.1502 30.768L92.7662 30.24C92.7662 30.24 92.6942 30.144 92.6942 30.12C92.3822 29.568 92.2382 28.968 92.2382 28.344C92.3102 27.312 92.3342 26.856 92.7182 25.776C94.2062 25.632 95.6702 24.624 96.5342 23.448C96.8222 23.064 97.1102 22.632 97.1342 22.152C97.1342 21.744 96.8462 21.36 96.5342 21.12C96.1502 20.808 95.7662 20.64 95.2622 20.64C94.4942 20.64 93.8702 21.072 93.2702 21.528C91.5182 22.92 90.4622 25.656 90.4622 27.984C90.4622 28.56 90.5342 29.136 90.7502 29.688C91.3262 31.2 92.7902 31.968 94.2782 31.968ZM92.9102 25.248C93.4382 23.784 94.4462 22.464 95.7662 21.864C95.9822 21.744 95.8622 21.792 96.1262 21.72C96.2462 21.72 96.2942 21.936 96.2942 22.032C96.2942 22.32 96.0782 22.656 95.9582 22.848C95.2622 24.096 94.1342 24.768 92.9102 25.248ZM103.739 38.616C104.987 38.52 106.139 37.776 106.835 36.744C107.603 35.592 107.987 34.248 108.203 32.88C108.587 30.672 108.731 29.52 108.779 27.192C108.779 26.088 108.707 24.96 108.515 23.832C108.299 22.512 108.131 20.64 106.715 20.496C106.619 20.496 106.499 20.52 106.451 20.568C105.131 22.08 104.651 24.144 103.787 25.896C103.571 26.304 103.379 26.784 103.115 27.168C103.091 27.168 103.067 27.192 103.043 27.216C103.043 24.576 103.259 24.168 104.075 21.96C104.171 21.744 104.195 21.624 104.243 21.384C104.243 20.976 103.739 20.712 103.307 20.712C103.115 20.712 102.947 20.76 102.827 20.88C102.035 21.72 101.675 23.016 101.459 24.168C101.339 24.768 101.267 25.368 101.243 25.992C101.243 26.28 101.243 26.544 101.267 26.832C101.267 27.144 101.267 27.48 101.387 27.768C101.627 28.392 102.299 28.68 102.875 28.68C103.043 28.68 103.163 28.632 103.355 28.536C103.835 28.32 104.123 27.84 104.339 27.384C104.795 26.4 105.107 25.32 105.491 24.312C105.923 23.208 106.403 22.176 107.051 21.192C107.195 21.408 107.267 21.768 107.291 21.984L107.315 22.512C107.315 22.944 107.267 23.376 107.243 23.808C106.883 29.256 107.075 28.92 106.187 33.816C105.899 35.664 105.203 37.656 103.331 37.92C103.187 37.944 103.091 38.064 103.091 38.184C103.187 38.472 103.355 38.616 103.691 38.616H103.739Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_159)",
    filter: "url(#filter0_d_9_159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.084 21.9929C132.019 21.7638 131.781 21.6307 131.552 21.6955C131.323 21.7604 131.19 21.9986 131.255 22.2276L132.429 26.3751L115.839 31.0702C114.693 31.3943 114.028 32.5855 114.352 33.7308C114.367 33.7996 114.386 33.8675 114.409 33.934C114.852 34.9802 116.013 35.5234 117.1 35.193L118.671 34.7481L118.085 32.6744L122.232 31.5006L122.819 33.5744L133.602 30.5226C134.06 30.3929 134.327 29.9164 134.197 29.4583L133.023 25.3109",
    fill: "#3B97D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.615 20.3339L132.839 24.6597L124.447 19.9702L126.325 16.6167C127.743 18.2854 129.564 19.5648 131.615 20.3339V20.3339Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.607 34.1534L116.865 34.3635C116.206 34.5708 115.497 34.2511 115.217 33.6205C115.201 33.5666 115.191 33.5292 115.181 33.496C114.987 32.8089 115.386 32.0942 116.073 31.8997L132.249 27.322C132.229 28.2032 132.475 29.07 132.953 29.8104L117.607 34.1534Z",
    fill: "#F5EFCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.839 24.6597L132.906 24.8961C133.035 25.3523 132.885 26.246 132.429 26.3751L132.395 26.3845L123.61 21.4749L118.692 30.2626L116.353 30.9246L121.681 21.3849L120.176 20.5475L118.674 19.7047L111.485 15.6873L110.822 13.344L122.529 19.8861L124.212 16.8743L114.846 11.6406L117.194 10.9762L125.048 15.3654L125.277 14.9557C125.561 15.5479 125.913 16.1052 126.325 16.6167L124.447 19.9702L132.839 24.6597Z",
    fill: "#F3D55B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.822 13.7449C124.94 14.1618 125.093 14.5681 125.278 14.9598L125.049 15.3695L117.194 10.9762L128.093 7.89157C125.574 8.60465 124.109 11.2253 124.822 13.7449Z",
    fill: "#F29C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.206 16.8713L122.523 19.8831L110.822 13.344L110.674 12.8214L114.846 11.6406L124.206 16.8713Z",
    fill: "#4FBA6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.674 12.8214L115.839 31.0702C114.693 31.3943 114.028 32.5855 114.352 33.7308L109.187 15.482C108.863 14.3367 109.529 13.1455 110.674 12.8214Z",
    fill: "#2980BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.906 24.8961L134.197 29.4583L131.957 30.0921C131.4 29.3897 131.147 28.4939 131.253 27.6037L132.663 27.2046C133.121 27.0749 133.388 26.5985 133.258 26.1403L132.906 24.8961Z",
    fill: "#285680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.906 24.8961L133.023 25.3109C133.007 25.2568 132.981 25.2065 132.945 25.1626C132.942 25.0726 132.929 24.9832 132.906 24.8961Z",
    fill: "#285680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.395 26.3845L118.692 30.2626L123.61 21.4749L132.395 26.3845Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.681 21.3849L116.353 30.9246L115.839 31.0702L114.657 26.8937L118.674 19.7047L120.176 20.5475L121.681 21.3849Z",
    fill: "#285680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.747 18.0692L113.366 22.3315L111.485 15.6873L115.747 18.0692Z",
    fill: "#285680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.674 19.7047L114.657 26.8937L113.366 22.3315L115.747 18.0692L118.674 19.7047Z",
    fill: "#4482C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.093 7.89157C125.574 8.60465 124.109 11.2253 124.822 13.7449C124.94 14.1618 125.093 14.5681 125.278 14.9598C125.562 15.552 125.914 16.1094 126.326 16.6208C127.745 18.2878 129.565 19.5658 131.615 20.3339C131.615 20.3339 135.286 15.8949 133.947 11.1626C133.604 9.95265 132.795 8.92827 131.698 8.31483C130.6 7.70139 129.303 7.54914 128.093 7.89157ZM129.971 14.5275C128.597 14.9164 127.168 14.1176 126.779 12.7433C126.39 11.3689 127.189 9.9395 128.563 9.55055C129.937 9.1616 131.367 9.96041 131.756 11.3348C131.942 11.9947 131.859 12.7019 131.525 13.3006C131.19 13.8994 130.631 14.3407 129.971 14.5275Z",
    fill: "#E64C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.971 14.5275C131.346 14.1385 132.145 12.7091 131.756 11.3348C131.367 9.96041 129.937 9.16159 128.563 9.55055C127.189 9.9395 126.39 11.3689 126.779 12.7433C127.168 14.1176 128.597 14.9164 129.971 14.5275Z",
    fill: "#F5EFCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.089 14.9422C128.485 15.396 126.818 14.4641 126.364 12.8607C125.91 11.2573 126.842 9.58958 128.446 9.1358C130.049 8.68202 131.717 9.61398 132.17 11.2174C132.388 11.9874 132.291 12.8124 131.901 13.5109C131.511 14.2095 130.859 14.7243 130.089 14.9422ZM128.68 9.96529C127.535 10.2894 126.869 11.4806 127.193 12.6259C127.518 13.7712 128.709 14.4369 129.854 14.1127C130.999 13.7886 131.665 12.5974 131.341 11.4521C131.185 10.9021 130.818 10.4365 130.319 10.1577C129.82 9.87885 129.23 9.80964 128.68 9.96529Z",
    fill: "#C03A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.008 31.4459L116.958 33.4413C116.729 33.5061 116.49 33.373 116.426 33.1439C116.361 32.9149 116.494 32.6766 116.723 32.6118L123.774 30.6164C124.003 30.5516 124.241 30.6847 124.306 30.9137C124.371 31.1428 124.237 31.381 124.008 31.4459Z",
    fill: "#E4C05C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.115 31.0859L123.171 34.8186C123.213 34.9676 123.172 35.1278 123.064 35.2382C122.955 35.3486 122.795 35.3922 122.646 35.3525L121.191 34.9622C121.042 34.9245 120.884 34.9692 120.777 35.0796L119.743 36.1741C119.635 36.2821 119.479 36.3253 119.331 36.288C119.184 36.2507 119.067 36.1383 119.024 35.9924L117.967 32.2597L122.115 31.0859Z",
    fill: "#E64C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.906 24.8961L133.023 25.3109C133.007 25.2568 132.981 25.2065 132.945 25.1626C132.942 25.0726 132.929 24.9832 132.906 24.8961Z",
    fill: "#3B97D3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9_159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.3 39.3106C100.3 39.3106 102.035 41.8742 98.0239 43.8407C98.0239 43.8407 96.2023 39.5361 100.3 39.3106Z",
    fill: "url(#paint0_linear_9_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0239 43.8407C98.4669 42.454 100.3 39.3106 100.3 39.3106C96.2023 39.5361 98.0239 43.8407 98.0239 43.8407Z",
    fill: "url(#paint1_linear_9_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.172 37.6901C101.172 37.6901 104.222 37.1648 104.363 41.6294C104.363 41.6294 99.6904 41.5177 101.172 37.6901Z",
    fill: "url(#paint2_linear_9_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.363 41.6295C103.282 40.6549 101.172 37.6901 101.172 37.6901C99.6904 41.5177 104.363 41.6295 104.363 41.6295Z",
    fill: "url(#paint3_linear_9_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.276 36.771C102.276 36.771 105.017 38.2085 106.524 34.0035C106.524 34.0035 102.043 32.6734 102.276 36.771Z",
    fill: "url(#paint4_linear_9_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.524 34.0035C105.195 34.5984 102.276 36.771 102.276 36.771C102.043 32.6734 106.524 34.0035 106.524 34.0035Z",
    fill: "url(#paint5_linear_9_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.3 39.3106C99.2491 39.3684 98.5876 39.6947 98.1847 40.1478L98.9123 41.5941L100.537 41.459C100.573 41.3544 100.601 41.2515 100.622 41.151C100.838 40.1062 100.3 39.3106 100.3 39.3106Z",
    fill: "url(#paint6_linear_9_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.172 37.6901C100.628 39.0963 100.914 40.0009 101.494 40.5828L104.224 40.3558C103.601 37.2719 101.172 37.6901 101.172 37.6901Z",
    fill: "url(#paint7_linear_9_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.276 36.771C102.276 36.771 105.017 38.2085 106.524 34.0035C106.524 34.0035 102.043 32.6734 102.276 36.771Z",
    fill: "url(#paint8_linear_9_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2821 36.4601C98.2821 36.4601 95.2223 35.7981 95.7037 34.9889C96.185 34.1797 95.1424 34.3306 95.9327 33.6628C96.723 32.995 96.0473 32.9998 96.9387 32.2329C97.8302 31.466 99.923 31.7783 99.8218 33.4944C99.7519 34.6776 100.338 37.1104 98.2821 36.4601Z",
    fill: "url(#paint9_radial_9_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0136 35.231C95.9823 35.2277 95.9507 35.2304 95.9204 35.2387L95.91 35.2396L95.9125 35.2413C95.8686 35.255 95.828 35.2806 95.7961 35.3183C95.7735 35.345 95.758 35.3751 95.7484 35.4066C95.7494 35.4079 95.7504 35.4092 95.7515 35.4105C95.7793 35.4457 95.8124 35.4804 95.8501 35.5145C95.8516 35.5158 95.853 35.5171 95.8544 35.5184C95.8736 35.5355 95.8939 35.5524 95.9153 35.5692C95.9166 35.5703 95.918 35.5714 95.9194 35.5724C95.9632 35.6066 96.0114 35.6401 96.0633 35.6728C96.0648 35.6738 96.0663 35.6747 96.0677 35.6756C96.1478 35.7259 96.2364 35.7746 96.3307 35.8212C97.1099 36.2064 98.2822 36.4601 98.2822 36.4601C99.6626 36.8968 99.852 35.9437 99.8485 34.9121L96.0136 35.231ZM96.2381 35.4824C96.2382 35.4738 96.2378 35.4653 96.237 35.4567L96.285 35.4886C96.2695 35.4866 96.2536 35.4844 96.2381 35.4824Z",
    fill: "url(#paint10_linear_9_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4595 36.3049C99.5414 36.2044 99.5828 36.077 99.5839 35.9475C99.5866 35.6436 99.5649 34.7901 99.2664 34.1366C98.897 33.3276 99.3107 34.6674 99.2341 35.2027C99.1576 35.7381 98.9222 34.6337 98.2495 34.1266C97.5768 33.6196 98.8278 35.3391 98.7941 35.7276C98.7604 36.1162 98.3454 35.3816 97.9299 35.2763C97.5145 35.171 98.2716 35.9894 98.4695 36.103C98.6674 36.2165 97.7909 36.0802 97.6496 36.1824C97.5082 36.2846 98.7276 36.5289 99.1134 36.4901C99.2787 36.4734 99.3883 36.3922 99.4595 36.3049Z",
    fill: "url(#paint11_linear_9_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8877 36.5438C98.8877 36.5438 96.9038 35.0158 95.5047 36.2517C94.1056 37.4877 95.3282 37.4133 95.0886 37.8155C94.849 38.2178 94.1098 38.8526 95.1176 39.8065C96.1254 40.7604 100.573 37.769 98.8877 36.5438Z",
    fill: "url(#paint12_radial_9_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1681 37.6662C99.3061 37.3349 99.1347 36.955 98.7994 36.8268C98.3682 36.662 97.7207 36.4307 97.3651 36.3783C96.8015 36.2953 97.6692 36.6871 97.9157 36.8615C98.1622 37.0358 97.0986 36.8551 96.5211 37.0517C95.9436 37.2481 96.3973 37.4609 96.8305 37.3136C97.2636 37.1662 97.0401 37.491 96.4986 37.7866C95.9572 38.0821 96.2958 38.2488 97.3495 37.7529C98.4032 37.257 98.8532 37.5351 98.4838 37.6679C98.1144 37.8007 97.6712 38.1623 97.5522 38.4042C97.4861 38.5383 98.3188 38.3265 98.8997 37.9786C99.0155 37.9092 99.1081 37.8062 99.1613 37.6822C99.1636 37.6768 99.1658 37.6715 99.1681 37.6662Z",
    fill: "url(#paint13_linear_9_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4845 37.5038C99.2468 37.4842 99.0117 37.5388 98.8065 37.651C98.3719 37.8886 97.4469 38.5074 97.0418 39.6385C96.5026 41.1435 97.5641 41.0274 97.8044 40.9079C98.0447 40.7883 98.2056 41.3678 98.8067 41.5633C99.4079 41.7588 99.8144 41.0893 100.306 41.1102C100.798 41.1311 101.021 41.3866 101.354 40.7811C101.687 40.1755 102.333 40.4222 101.662 39.2081C101.102 38.1963 100.248 37.5667 99.4845 37.5038Z",
    fill: "url(#paint14_radial_9_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4625 35.8261C99.4625 35.8261 99.2371 33.5148 100.455 32.6788C100.938 32.4165 101.346 32.8571 101.683 32.6281C102.019 32.3991 102.885 32.7865 102.754 33.2736C102.623 33.7607 103.678 33.9524 103.586 34.6086C103.493 35.2648 99.4722 38.0595 99.4625 35.8261Z",
    fill: "url(#paint15_radial_9_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.586 34.6012L99.4622 34.9442C99.4258 35.4489 99.4625 35.8261 99.4625 35.8261C99.4703 37.6297 102.094 36.1543 103.152 35.174C103.183 35.145 103.213 35.1165 103.242 35.0885C103.242 35.0881 103.243 35.0877 103.243 35.0873C103.271 35.0597 103.298 35.0325 103.323 35.006C103.323 35.0053 103.324 35.0046 103.325 35.004C103.349 34.9779 103.372 34.9524 103.394 34.9276C103.395 34.9265 103.396 34.9255 103.397 34.9245C103.418 34.9001 103.437 34.8764 103.455 34.8534C103.456 34.8522 103.457 34.8509 103.458 34.8497C103.466 34.8385 103.475 34.8275 103.483 34.8166C103.483 34.8156 103.484 34.8146 103.485 34.8135C103.492 34.8035 103.499 34.7937 103.505 34.784C103.506 34.7828 103.507 34.7815 103.508 34.7802C103.515 34.7701 103.521 34.7602 103.527 34.7505C103.528 34.7489 103.529 34.7473 103.53 34.7457C103.535 34.7369 103.54 34.7283 103.545 34.7199C103.545 34.7188 103.546 34.7177 103.546 34.7166C103.551 34.7075 103.555 34.6987 103.559 34.6901C103.56 34.6883 103.561 34.6865 103.562 34.6847C103.565 34.6767 103.569 34.6689 103.572 34.6614C103.572 34.6607 103.572 34.6599 103.572 34.6592C103.575 34.6512 103.578 34.6434 103.58 34.6359C103.58 34.6341 103.581 34.6324 103.581 34.6306C103.583 34.6231 103.585 34.6158 103.586 34.6088C103.586 34.6088 103.586 34.6087 103.586 34.6087C103.586 34.6061 103.586 34.6037 103.586 34.6012Z",
    fill: "url(#paint16_linear_9_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7484 36.4486C99.6712 36.3446 99.6355 36.2155 99.6402 36.086C99.6511 35.7823 99.7109 34.9306 100.038 34.2911C100.444 33.4996 99.9703 34.8194 100.023 35.3577C100.075 35.8959 100.36 34.8031 101.055 34.3267C101.749 33.8503 100.423 35.5121 100.439 35.9017C100.455 36.2914 100.903 35.5761 101.322 35.4895C101.742 35.4029 100.949 36.1866 100.746 36.2912C100.544 36.3958 101.425 36.2988 101.562 36.4072C101.699 36.5156 100.47 36.7051 100.086 36.6491C99.9215 36.6251 99.8157 36.5391 99.7484 36.4486Z",
    fill: "url(#paint17_linear_9_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.87 36.6336C99.87 36.6336 100.619 34.8118 102.334 34.8192C102.993 34.877 102.813 35.1644 103.43 35.2357C104.047 35.3069 104.196 35.829 104.098 36.3638C103.999 36.8985 104.723 37.6427 104.049 38.1612C103.374 38.6797 103.073 38.4589 102.948 38.8425C102.823 39.2262 102.478 39.6364 101.547 39.0972C100.616 38.558 99.5652 37.3047 99.87 36.6336Z",
    fill: "url(#paint18_radial_9_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4086 37.4921C99.2793 37.501 99.1581 37.558 99.0628 37.6458C98.8393 37.8517 98.2315 38.4513 97.9589 39.116C97.6215 39.9388 98.3158 38.7206 98.7588 38.4103C99.2017 38.1 98.557 39.0271 98.6472 39.8646C98.7374 40.7021 99.1361 38.6134 99.4426 38.3722C99.7491 38.1311 99.4971 38.9363 99.7044 39.3114C99.9118 39.6865 99.991 38.5744 99.9384 38.3523C99.8859 38.1303 100.386 38.8629 100.557 38.8961C100.728 38.9294 100.073 37.8727 99.7804 37.6178C99.6552 37.5086 99.521 37.4842 99.4086 37.4921Z",
    fill: "url(#paint19_linear_9_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9371 37.2686C99.7249 36.979 99.802 36.5695 100.098 36.3659C100.478 36.1042 101.053 35.7269 101.386 35.5922C101.914 35.3788 101.163 35.9639 100.965 36.1914C100.766 36.4189 101.647 36.1315 102.254 36.1865C102.862 36.2414 102.469 36.4542 102.013 36.413C101.558 36.3717 101.69 36.6929 102.56 36.7568C103.175 36.8019 102.8 37.1401 101.682 36.9933C100.527 36.8416 100.161 37.1263 100.547 37.2009C100.98 37.2847 101.357 37.285 101.53 37.4921C101.626 37.6069 100.918 37.7102 100.271 37.5088C100.143 37.4687 100.028 37.3904 99.9474 37.2824C99.9439 37.2778 99.9405 37.2732 99.9371 37.2686Z",
    fill: "url(#paint20_linear_9_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.38 35.2291C103.375 35.2283 103.37 35.2275 103.365 35.2267C103.354 35.225 103.343 35.2233 103.333 35.2214C103.327 35.2205 103.322 35.2196 103.317 35.2185C103.306 35.2166 103.296 35.2145 103.286 35.2123C103.282 35.2114 103.278 35.2106 103.274 35.2097C103.262 35.2069 103.249 35.204 103.238 35.2009C103.232 35.1994 103.226 35.1978 103.221 35.1962C103.215 35.1944 103.208 35.1927 103.202 35.1908C103.196 35.189 103.19 35.1872 103.185 35.1853C103.179 35.1836 103.174 35.1819 103.169 35.1802C103.164 35.1782 103.158 35.1762 103.152 35.1741L103.152 35.1741C102.851 35.0628 102.867 34.8659 102.334 34.8193C100.619 34.8119 99.87 36.6337 99.87 36.6337C99.7384 36.9235 99.5958 37.3439 99.851 37.7465L104.316 37.3809C104.311 37.359 104.306 37.337 104.301 37.3149C104.301 37.3146 104.301 37.3143 104.301 37.314C104.273 37.1974 104.233 37.0802 104.195 36.9651C104.192 36.9541 104.188 36.9432 104.185 36.9322C104.182 36.9253 104.18 36.9184 104.178 36.9115C104.172 36.8928 104.166 36.8741 104.161 36.8555C104.16 36.8525 104.159 36.8495 104.158 36.8466C104.152 36.8282 104.147 36.8099 104.142 36.7917C104.141 36.7888 104.14 36.7858 104.139 36.7828C104.134 36.7646 104.13 36.7464 104.125 36.7284C104.124 36.7257 104.124 36.723 104.123 36.7204C104.118 36.7017 104.114 36.6831 104.11 36.6646C104.11 36.6628 104.11 36.661 104.109 36.6592C104.105 36.6393 104.102 36.6195 104.099 36.5999C104.099 36.5991 104.099 36.5984 104.098 36.5976C104.096 36.5785 104.093 36.5596 104.092 36.5408C104.091 36.539 104.091 36.5372 104.091 36.5353C104.09 36.5174 104.089 36.4996 104.089 36.4821C104.089 36.4801 104.088 36.4781 104.088 36.4761C104.088 36.4584 104.089 36.4409 104.09 36.4235C104.09 36.422 104.09 36.4205 104.091 36.419C104.092 36.4004 104.094 36.382 104.098 36.3638C104.147 36.0965 104.134 35.8323 104.032 35.626C104.013 35.5873 103.991 35.5507 103.965 35.5164C103.957 35.505 103.948 35.4939 103.939 35.483C103.92 35.4613 103.9 35.4407 103.878 35.4213C103.77 35.3243 103.623 35.258 103.43 35.2357C103.413 35.2337 103.396 35.2314 103.38 35.2291Z",
    fill: "url(#paint21_linear_9_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9474 35.511C93.9474 35.511 96.7956 35.982 97.8178 36.7884C98.84 37.5948 99.6911 37.9952 100.109 37.612C100.527 37.2288 100.215 36.2607 98.394 35.851C96.5728 35.4413 94.5336 35.3022 93.9486 35.2721C93.3636 35.2421 93.5413 35.519 93.9474 35.511Z",
    fill: "url(#paint22_linear_9_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0902 35.6887C94.2704 35.4758 94.2439 35.1572 94.031 34.977C93.8181 34.7968 93.4995 34.8233 93.3193 35.0362C93.1392 35.2491 93.1657 35.5677 93.3785 35.7479C93.5914 35.9281 93.91 35.9016 94.0902 35.6887Z",
    fill: "url(#paint23_radial_9_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8183 35.973C94.9077 35.8673 94.8946 35.7091 94.7889 35.6196C94.6832 35.5301 94.5249 35.5433 94.4355 35.649C94.346 35.7547 94.3591 35.9129 94.4649 36.0024C94.5706 36.0919 94.7288 36.0787 94.8183 35.973Z",
    fill: "url(#paint24_radial_9_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2089 35.3478C95.2984 35.2421 95.2852 35.0839 95.1795 34.9944C95.0738 34.905 94.9156 34.9181 94.8261 35.0238C94.7366 35.1295 94.7498 35.2878 94.8555 35.3772C94.9612 35.4667 95.1194 35.4536 95.2089 35.3478Z",
    fill: "url(#paint25_radial_9_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6242 36.1012C95.7137 35.9955 95.7006 35.8373 95.5949 35.7478C95.4891 35.6583 95.3309 35.6715 95.2414 35.7772C95.152 35.8829 95.1651 36.0411 95.2708 36.1306C95.3765 36.2201 95.5348 36.2069 95.6242 36.1012Z",
    fill: "url(#paint26_radial_9_159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.179 35.6423C96.2684 35.5366 96.2553 35.3784 96.1496 35.2889C96.0439 35.1995 95.8857 35.2126 95.7962 35.3183C95.7067 35.424 95.7199 35.5823 95.8256 35.6717C95.9313 35.7612 96.0895 35.7481 96.179 35.6423Z",
    fill: "url(#paint27_radial_9_159)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_9_159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.16 8.26959C48.0714 8.36497 47.9831 8.46208 47.895 8.56111C47.8644 8.48471 47.8372 8.4082 47.8134 8.33137C47.7974 8.27989 47.8411 8.22951 47.8944 8.23705C47.9853 8.25008 48.074 8.26072 48.16 8.26959Z",
    fill: "#47821C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6495 7.22115C58.2159 7.17846 58.5203 7.00216 59.2799 6.75452C59.4066 6.71321 59.4975 6.60106 59.5101 6.46839C59.622 5.28193 59.5559 4.29282 59.4716 3.64976C59.4038 3.13263 59.0631 2.69314 58.5823 2.49096C57.8786 2.19508 57.1733 2.02228 56.4992 1.93354C56.382 1.91813 56.266 1.96684 56.1928 2.05956C55.6678 2.72429 55.1262 3.24688 54.8832 4.10619C54.8614 4.1833 54.7498 4.17593 54.7392 4.09652C54.6808 3.66134 54.6176 2.87875 54.7196 1.92061C54.7246 1.8737 54.6854 1.83389 54.6385 1.83902C54.0849 1.89968 53.2874 2.04785 52.902 2.13809C52.8795 2.14337 52.8609 2.1588 52.8517 2.18005C52.4507 3.105 51.9444 4.43413 51.7829 5.56526C51.7712 5.64698 51.6549 5.65109 51.6378 5.57034C51.5028 4.93445 51.2764 3.74169 51.2617 2.83086C51.2608 2.77377 51.1986 2.73916 51.1498 2.76889C50.9809 2.87194 50.6916 3.05222 50.588 3.11635C50.5748 3.12453 50.5647 3.13651 50.5588 3.15096C50.2399 3.94171 49.9081 5.07343 50.058 6.11045C50.0681 6.18015 49.9855 6.22355 49.9343 6.17518C49.6617 5.91759 49.1227 5.32727 48.9708 4.568C48.9589 4.50847 48.8842 4.48759 48.8438 4.5329C48.3234 5.11637 47.9689 5.74883 47.7773 6.55927C47.772 6.58159 47.7776 6.60495 47.7922 6.62264C48.2216 7.14252 48.7282 7.86223 49.5454 8.12524C49.6212 8.14965 49.6112 8.25965 49.5322 8.26873C49.1801 8.30919 48.6043 8.33814 47.8933 8.23695C47.84 8.22937 47.7961 8.27973 47.8122 8.33119C47.9462 8.76249 48.1837 9.18837 48.5476 9.6038C48.9258 10.0856 49.8777 10.3042 50.2998 9.42717C50.3944 9.23128 50.4408 8.81207 50.5798 8.63868C50.8866 8.25588 51.1619 8.09009 51.4718 7.82772C52.0191 7.38735 52.7492 7.39503 53.1039 7.84462C53.4565 8.29603 53.3016 9.02141 52.7542 9.46187C52.4298 9.70985 52.2107 9.94212 51.7725 10.1587C51.5743 10.2566 51.165 10.1486 50.9552 10.1977C50.7722 10.2402 50.6084 10.3244 50.4709 10.435C50.046 10.7769 50.0778 11.5537 50.3851 11.9452C50.6947 12.3869 51.041 12.7122 51.4147 12.941C51.4666 12.9728 51.5329 12.9315 51.5269 12.8709C51.4328 11.9243 51.6234 11.3968 51.7575 11.1502C51.7917 11.0873 51.8866 11.1061 51.8951 11.1772C52.0052 12.097 52.264 12.767 52.6806 13.3414C52.6943 13.3603 52.7162 13.3714 52.7396 13.3714C53.0255 13.3714 53.6514 13.3659 53.9127 13.3214C54.4155 13.2359 54.893 13.0447 55.3333 12.7968C55.3857 12.7674 55.3816 12.6912 55.3271 12.666C54.638 12.3487 54.1935 11.6944 54.0034 11.3632C53.9671 11.3 54.035 11.2281 54.1002 11.2606C54.9807 11.6981 55.5716 12.0957 56.5475 12.018C56.5651 12.0167 56.5816 12.0089 56.5939 11.9963C56.7517 11.8347 57.6917 10.8774 58.0457 10.5133C58.0921 10.4656 58.0562 10.3862 57.9898 10.3887C56.7611 10.434 55.6546 9.79451 55.1741 9.46869C55.109 9.42455 55.149 9.32289 55.2267 9.33493C56.321 9.50473 57.4869 9.56396 58.4982 9.3764C58.5213 9.37211 58.5408 9.35716 58.551 9.33604C58.7249 8.97597 59.0478 8.22217 59.2312 7.68979C59.2465 7.64523 59.2165 7.59793 59.1697 7.59251C58.512 7.51643 58.003 7.43482 57.6418 7.36715C57.5572 7.35134 57.5637 7.22763 57.6495 7.22115Z",
    fill: "#4E901E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1839 2.95489C58.4972 3.50747 53.8064 7.28207 53.1052 7.84636C53.0872 7.82924 52.9718 7.66183 52.7242 7.56894C52.724 7.56869 52.7235 7.56863 52.723 7.56858C52.3191 7.41157 51.8246 7.54326 51.4717 7.82783C51.0757 8.15042 50.8511 8.30075 50.5798 8.6388C50.4995 8.73845 50.4413 8.95625 50.4407 8.96128C50.3633 9.23025 50.3298 9.55929 49.9621 9.85143C49.5372 10.1932 48.8549 9.9955 48.5477 9.60374C48.2484 9.26227 48.0348 8.91383 47.8938 8.56098C47.8632 8.48458 47.836 8.40807 47.8122 8.33124C47.7962 8.27976 47.8399 8.22937 47.8932 8.23691C47.984 8.24995 48.0728 8.26056 48.1588 8.26946C48.7478 8.3306 49.2252 8.30416 49.5321 8.26876C49.6109 8.2593 49.6214 8.15044 49.5454 8.1252C49.2369 8.02587 48.9747 7.86323 48.742 7.66827C48.3723 7.35904 48.0779 6.96874 47.7922 6.62284L47.7923 6.62261C47.7775 6.60486 47.772 6.58167 47.7772 6.55925C47.9667 5.75641 48.3233 5.11538 48.8439 4.53293C48.8841 4.48741 48.9589 4.50844 48.9708 4.56783C49.1228 5.32724 49.6618 5.91748 49.9343 6.17504C49.9856 6.22335 50.0682 6.18005 50.058 6.11028C49.9182 5.14362 50.1943 4.05306 50.5587 3.15106L50.559 3.15086C50.5694 3.12472 50.5368 3.14304 51.15 2.76881C51.186 2.74704 51.2314 2.75894 51.2532 2.79717C51.2939 2.87327 51.2075 3.48169 51.6004 5.39103C51.6124 5.44948 51.6249 5.50945 51.6379 5.57039C51.655 5.65101 51.7713 5.64681 51.7828 5.56516C51.7978 5.45966 51.8161 5.35241 51.8369 5.24398C52.0378 4.18969 52.4881 3.01858 52.8517 2.18002C52.8609 2.15877 52.8794 2.14339 52.9021 2.13805C53.3785 2.02635 54.1749 1.89036 54.6386 1.83908C54.6855 1.83389 54.7246 1.87363 54.7197 1.92054C54.6395 2.67099 54.6514 3.41968 54.7391 4.0963C54.7502 4.16303 54.8223 4.17608 54.8617 4.14199L54.8617 4.14176C54.9081 4.10464 54.9093 3.89389 55.1521 3.45072C55.1521 3.45049 55.1521 3.45049 55.1521 3.45049C55.4443 2.92175 55.8058 2.55014 56.1928 2.05962C56.266 1.96679 56.3822 1.91821 56.4991 1.93351C57.2937 2.03569 58.1488 2.28869 58.5861 2.4927C58.8258 2.59423 59.0307 2.75486 59.1839 2.95489Z",
    fill: "#5EAC24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5057 6.49747C59.4833 6.61577 59.3982 6.71589 59.2799 6.75463C58.5203 7.00227 58.216 7.17851 57.6494 7.22114C57.5628 7.22755 57.5586 7.35247 57.6416 7.36725C58.0029 7.43497 58.5119 7.51647 59.1696 7.59268C59.2162 7.59801 59.2463 7.64534 59.2312 7.6899C59.0477 8.22219 58.7248 8.97594 58.5509 9.33617C58.5406 9.35729 58.5212 9.37211 58.4981 9.37643C57.5859 9.54571 56.5482 9.51403 55.5508 9.38169C55.4421 9.36733 55.3341 9.35161 55.2266 9.33501C55.1489 9.32298 55.1089 9.42467 55.1739 9.4688C55.2284 9.50573 55.2913 9.54698 55.3614 9.59074C55.9076 9.9312 56.9006 10.429 57.9897 10.3888C58.0557 10.3861 58.0922 10.4656 58.0455 10.5134C56.4817 12.1209 56.5803 12.0145 56.5473 12.0182C55.5715 12.0958 54.9804 11.6981 54.1002 11.2607C54.0349 11.2283 53.9669 11.3002 54.0033 11.3633C54.6049 12.4104 55.3199 12.6402 55.3552 12.6888C55.3737 12.713 55.3751 12.7467 55.3587 12.7729C55.3587 12.7732 55.3585 12.7731 55.3585 12.7731C55.3268 12.8215 54.6329 13.199 53.9127 13.3214C53.6512 13.3659 53.0253 13.3715 52.7395 13.3714C52.7152 13.3717 52.6927 13.3593 52.6803 13.3414C51.8914 12.2495 51.956 11.208 51.8724 11.1322C51.8401 11.1021 51.7825 11.1042 51.7573 11.1502C51.3696 11.8637 51.5451 12.8395 51.5234 12.9018C51.5111 12.9399 51.4623 12.9684 51.4146 12.9411C51.0033 12.6893 50.6651 12.345 50.385 11.9453C50.0777 11.5538 50.046 10.777 50.471 10.4352C50.6083 10.3245 50.7722 10.2403 50.9552 10.1977C51.1649 10.1488 51.5744 10.2566 51.7725 10.1586C52.1564 9.97038 52.3912 9.74808 52.471 9.68982C52.4824 9.67218 52.8107 9.44139 52.9625 9.25969C52.9625 9.25969 52.9625 9.25946 52.963 9.25927C53.3366 8.82163 53.4091 8.23374 53.1052 7.84641C53.1111 7.8417 59.1127 3.01229 59.184 2.95491C59.3365 3.15392 59.4378 3.39238 59.4716 3.64973C59.6368 4.91139 59.5357 6.35892 59.5057 6.49747Z",
    fill: "#4E901E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1499 2.76883C50.5368 3.14309 50.5694 3.12474 50.5589 3.15088L50.5587 3.15108C50.1943 4.05311 49.9182 5.14367 50.058 6.11031C50.0682 6.18007 49.9856 6.22337 49.9343 6.17506C49.6618 5.9175 49.1228 5.32724 48.9708 4.56785C48.9589 4.50845 48.8841 4.48742 48.8439 4.53295C48.3232 5.1154 47.9667 5.75643 47.7772 6.55927C47.772 6.5817 47.7775 6.60488 47.7922 6.62263L47.7922 6.62286C48.0778 6.96876 48.3723 7.35907 48.742 7.66829C49.6879 6.73759 50.654 5.9905 51.6003 5.39106C51.2075 3.48172 51.2939 2.8733 51.2532 2.7972C51.2314 2.75898 51.186 2.74704 51.1499 2.76883Z",
    fill: "#6DC82A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6386 1.83912C54.1749 1.89038 53.3784 2.02639 52.9021 2.13809C52.8794 2.1434 52.8609 2.15881 52.8517 2.18006C52.4881 3.01862 52.0378 4.18973 51.8368 5.24402C52.8372 4.63395 53.8114 4.18664 54.712 3.85896C54.6492 3.23684 54.6494 2.57881 54.7196 1.9206C54.7246 1.87364 54.6854 1.83391 54.6386 1.83912Z",
    fill: "#6DC82A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5861 2.49269C58.1488 2.28869 57.2937 2.03569 56.4991 1.93351C56.3822 1.9182 56.266 1.96679 56.1928 2.05962C55.8057 2.55014 55.4442 2.92177 55.1521 3.45048C55.1521 3.45048 55.1521 3.45048 55.1521 3.45071C55.0878 3.56807 55.0402 3.66935 55.0044 3.75566C57.5231 2.89538 59.0994 3.02283 59.1839 2.95488C59.0307 2.75486 58.8258 2.59423 58.5861 2.49269Z",
    fill: "#6DC82A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9897 10.3888C56.9006 10.429 55.9076 9.93114 55.3614 9.59069C54.4759 10.5509 53.4026 11.4593 52.1077 12.2069C52.2168 12.5482 52.3915 12.9416 52.6803 13.3413C52.6927 13.3593 52.7152 13.3717 52.7395 13.3713C53.0253 13.3714 53.6512 13.3658 53.9127 13.3214C54.6329 13.199 55.3268 12.8215 55.3584 12.7731C55.3584 12.7731 55.3587 12.7731 55.3587 12.7729C55.3751 12.7467 55.3737 12.7129 55.3551 12.6888C55.3199 12.6401 54.6049 12.4103 54.0033 11.3633C53.9669 11.3001 54.0348 11.2283 54.1002 11.2607C54.9804 11.6981 55.5714 12.0957 56.5473 12.0181C56.5803 12.0145 56.4858 12.1166 58.0454 10.5134C58.0922 10.4655 58.0557 10.386 57.9897 10.3888Z",
    fill: "#5EAC24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4716 3.6497C59.4377 3.39232 59.3364 3.15386 59.1839 2.95488C59.1738 3.0441 59.1226 3.29007 59.0567 3.44741C58.5106 4.74987 57.5772 7.10002 55.5508 9.38167C56.5482 9.514 57.5859 9.54568 58.4981 9.3764C58.5212 9.37208 58.5406 9.35727 58.5509 9.33615C58.7248 8.97592 59.0477 8.22217 59.2312 7.68987C59.2463 7.64532 59.2162 7.59799 59.1696 7.59266C58.5119 7.51645 58.0029 7.43495 57.6416 7.36723C57.5586 7.35245 57.5628 7.22752 57.6494 7.22111C58.216 7.17849 58.5203 7.00227 59.2799 6.7546C59.3982 6.71587 59.4833 6.61575 59.5057 6.49745C59.5357 6.35892 59.6368 4.91139 59.4716 3.6497Z",
    fill: "#5EAC24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0111 1.92607C53.9041 2.27429 53.6527 3.14414 53.4906 4.12327C53.4748 4.21764 53.388 4.28228 53.294 4.27153C53.1928 4.25995 53.1212 4.16602 53.138 4.06495C53.2809 3.20163 53.4921 2.42044 53.618 1.99333C53.7458 1.97029 53.8789 1.94738 54.0111 1.92607Z",
    fill: "#47821C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0801 6.1103C57.1153 6.20235 57.069 6.3057 56.9769 6.34097C56.0919 6.67883 55.3046 6.85448 54.6369 6.863C54.5145 6.86429 54.3655 6.6783 54.3949 6.55783C54.7741 4.9914 56.17 3.21994 57.2852 2.07474C57.4184 2.10509 57.5524 2.13936 57.6869 2.17753C57.3725 2.48979 55.3182 4.58346 54.7796 6.50064C55.3737 6.47054 56.069 6.30497 56.8494 6.00695C56.9417 5.97193 57.0448 6.01802 57.0801 6.1103Z",
    fill: "#47821C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5254 4.15349C58.9977 4.43295 57.244 5.33525 56.2088 5.55664C56.0944 5.58167 55.9901 5.48915 55.9899 5.37834C55.9894 4.45694 57.6293 2.98289 58.3361 2.3926C58.4655 2.4418 58.6131 2.50006 58.7046 2.54938C58.7024 2.55189 56.7141 4.15783 56.39 5.14234C57.5183 4.8184 59.2799 3.88006 59.4864 3.76891C59.5005 3.8873 59.5139 4.0157 59.5254 4.15349Z",
    fill: "#47821C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2497 5.34751C48.7943 5.96406 50.2832 7.5695 51.3282 7.9433C51.0621 8.15766 51.0556 8.16179 51.0117 8.19872C49.9592 7.71376 48.6591 6.34457 48.0741 5.68933C48.1271 5.57236 48.1859 5.45846 48.2497 5.34751Z",
    fill: "#47821C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6902 7.68037C51.5373 7.76552 51.4477 7.8493 51.3964 7.88826C50.9196 7.00653 50.5576 5.12256 50.3427 3.74583C50.4114 3.53306 50.4856 3.3329 50.559 3.15086C50.5696 3.12394 50.5894 3.11613 50.6098 3.10271C50.8 4.43347 51.1825 6.70399 51.6902 7.68037Z",
    fill: "#47821C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.568 5.03947C59.2042 5.26527 58.4966 5.68145 57.647 6.06223C57.6167 6.0758 57.5845 6.08026 57.5537 6.07674C57.3729 6.05605 57.336 5.80994 57.5009 5.73614C58.4953 5.2904 59.3104 4.78195 59.5559 4.62368C59.5663 4.84943 59.5671 5.00117 59.568 5.03947Z",
    fill: "#47821C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1152 11.0264C53.1568 11.116 53.1178 11.2221 53.0281 11.2637C52.9387 11.3049 52.8326 11.2661 52.7908 11.1763C52.5455 10.6463 52.3901 10.1868 52.327 9.80543C52.7467 9.46781 52.6364 9.5565 52.6553 9.5413C52.6795 9.91938 52.8341 10.4186 53.1152 11.0264Z",
    fill: "#47821C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3175 11.2582C57.2204 11.3569 57.1245 11.4548 57.0357 11.5457C56.0102 11.2228 53.6057 10.4012 52.672 9.52807C52.7252 9.48289 52.8242 9.41478 52.9379 9.28774C53.8809 10.1463 56.454 10.9913 57.3175 11.2582Z",
    fill: "#47821C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3811 13.2102C54.26 13.2472 54.137 13.2782 54.0124 13.3028C53.8028 12.9903 53.447 12.4385 53.1171 11.8257C53.0704 11.739 53.1029 11.6305 53.1898 11.5836C53.2767 11.537 53.385 11.5695 53.4319 11.6564C53.7976 12.3357 54.1956 12.9383 54.3811 13.2102Z",
    fill: "#47821C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9985 8.30669C58.9485 8.43072 58.8971 8.55507 58.8468 8.67426C58.2482 8.70818 57.1374 8.74537 56.1709 8.64007C56.1545 8.63842 56.1385 8.63658 56.1224 8.63474C55.1009 8.51787 54.0376 8.24441 53.3953 7.64931C53.3801 7.63533 53.3658 7.61619 53.3576 7.60158C53.0336 7.01915 52.9095 6.17971 52.9885 5.1069C52.996 5.00847 53.0817 4.93456 53.1801 4.94175C53.2785 4.94941 53.3522 5.03483 53.345 5.13306C53.2721 6.12048 53.3773 6.88411 53.6572 7.40395C54.2603 7.94781 55.3702 8.18823 56.4427 8.28527C57.5109 8.38184 58.5421 8.33625 58.9985 8.30669Z",
    fill: "#47821C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9_159",
    x: 104.6,
    y: 6.60042,
    width: 38.8631,
    height: 38.8631,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9_159"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9_159",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_159",
    x1: 96.9706,
    y1: 44.123,
    x2: 101.594,
    y2: 37.9022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.018,
    stopColor: "#FCE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.319,
    stopColor: "#C5DD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#AFDC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#A7D200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#93B800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#718E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#586E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_159",
    x1: 97.6699,
    y1: 41.234,
    x2: 100.434,
    y2: 41.8671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFDC00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#84A600",
    stopOpacity: 0.472
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#586E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9_159",
    x1: 104.187,
    y1: 42.7056,
    x2: 100.42,
    y2: 35.9312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.018,
    stopColor: "#FCE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.319,
    stopColor: "#C5DD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#AFDC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#A7D200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#93B800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#718E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#586E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9_159",
    x1: 101.841,
    y1: 40.8793,
    x2: 103.557,
    y2: 38.6206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFDC00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#84A600",
    stopOpacity: 0.472
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#586E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9_159",
    x1: 106.687,
    y1: 32.9252,
    x2: 101.02,
    y2: 38.2134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.018,
    stopColor: "#FCE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.319,
    stopColor: "#C5DD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#AFDC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#A7D200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#93B800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#718E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#586E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9_159",
    x1: 103.893,
    y1: 33.9421,
    x2: 104.831,
    y2: 36.6188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFDC00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#84A600",
    stopOpacity: 0.472
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#586E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9_159",
    x1: 102.477,
    y1: 41.2618,
    x2: 98.6294,
    y2: 40.1769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFDC00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#84A600",
    stopOpacity: 0.472
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#586E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9_159",
    x1: 104.993,
    y1: 38.8306,
    x2: 100.658,
    y2: 39.1911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFDC00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#84A600",
    stopOpacity: 0.472
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#586E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9_159",
    x1: 105.484,
    y1: 35.1435,
    x2: 103.25,
    y2: 35.5612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFDC00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#84A600",
    stopOpacity: 0.472
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#586E00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_9_159",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.972 38.4169) rotate(-61.835) scale(6.66052 6.66091)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FF5F47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#FF684E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#FF785B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#FF8E6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#FFA981"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9_159",
    x1: 99.5947,
    y1: 33.5305,
    x2: 96.9075,
    y2: 36.7053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA981",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B82934"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9_159",
    x1: 97.3006,
    y1: 33.7401,
    x2: 99.8011,
    y2: 36.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA981",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B82934"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_9_159",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.816 35.9631) rotate(-49.7538) scale(6.8274)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FF5F47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#FF684E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#FF785B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#FF8E6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#FFA981"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_9_159",
    x1: 95.0318,
    y1: 37.5442,
    x2: 100.529,
    y2: 37.2277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA981",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B82934"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_9_159",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.8685 33.1329) rotate(-41.0981) scale(7.08039 7.39718)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FF5F47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#FF684E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#FF785B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#FF8E6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#FFA981"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_9_159",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.3353 39.3932) rotate(-61.9273) scale(6.34532 7.3281)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FF5F47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#FF684E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#FF785B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#FF8E6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#FFA981"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_9_159",
    x1: 102.347,
    y1: 35.0903,
    x2: 98.7348,
    y2: 36.1859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA981",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B82934"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_9_159",
    x1: 102.02,
    y1: 33.9831,
    x2: 99.3869,
    y2: 36.8824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA981",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B82934"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_9_159",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(96.6077 34.6424) rotate(-63.1865) scale(6.41118)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FF5F47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#FF684E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#FF785B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#FF8E6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#FFA981"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_9_159",
    x1: 99.014,
    y1: 40.8222,
    x2: 99.5025,
    y2: 36.9365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA981",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B82934"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_9_159",
    x1: 103.923,
    y1: 36.121,
    x2: 98.5003,
    y2: 37.1095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA981",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B82934"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_9_159",
    x1: 105.216,
    y1: 35.9385,
    x2: 96.8627,
    y2: 36.6333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA981",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B82934"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_9_159",
    x1: 96.7824,
    y1: 36.931,
    x2: 97.134,
    y2: 35.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFFB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD77"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_9_159",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.4583 35.3203) rotate(-49.7538) scale(1.10752)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFFB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#FEF296"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#FFD14B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAF00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_9_159",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.5046 35.7901) rotate(-49.7538) scale(0.549939)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFFB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#FEF296"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#FFD14B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAF00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_9_159",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.8953 35.165) rotate(-49.7538) scale(0.549939)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFFB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#FEF296"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#FFD14B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAF00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_9_159",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.3106 35.9183) rotate(-49.7538) scale(0.549939)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFFB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#FEF296"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#FFD14B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAF00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_9_159",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.8653 35.4594) rotate(-49.7538) scale(0.549939)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFFB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#FEF296"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#FFD14B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAF00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(108.6 13.4083) rotate(-15.8021)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9_159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(90.8227 37.7453) rotate(-49.7538)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_9_159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.7917,
    height: 11.7917,
    fill: "white",
    transform: "translate(48.3403 1) rotate(6.52691)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconLogin);
export default __webpack_public_path__ + "static/media/nav-icon-login.da5952c474cebf06e5a972b2818e8b4e.svg";
export { ForwardRef as ReactComponent };